import type { ReactNode } from 'react';
import { StateBlock } from '@promtver/ui-kit';

import { ru } from '../i18n/ru';

export interface AsyncStateProps {
  isLoading: boolean;
  isError: boolean;
  isEmpty?: boolean;
  emptyTitle?: string;
  emptyDescription?: string;
  onRetry?: () => void;
  children: ReactNode;
}

/** Единая обработка состояний списка: загрузка / пусто / ошибка (ТЗ §8.1). */
export function AsyncState({
  isLoading,
  isError,
  isEmpty = false,
  emptyTitle = ru.common.empty,
  emptyDescription = ru.common.emptyDescription,
  onRetry,
  children,
}: AsyncStateProps) {
  if (isLoading) {
    return <StateBlock kind="loading" title={ru.common.loading} />;
  }
  if (isError) {
    return (
      <StateBlock
        kind="error"
        title={ru.common.error}
        description={ru.common.errorDescription}
        actionLabel={onRetry ? ru.common.retry : undefined}
        onAction={onRetry}
      />
    );
  }
  if (isEmpty) {
    return <StateBlock kind="empty" title={emptyTitle} description={emptyDescription} />;
  }
  return <>{children}</>;
}
